import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class PreferenceService {

	private preferenceUrl = '';

	preferences: any = {};

	constructor(private http: HttpClient) {
	}

	getPreference(preferenceCode: string): Observable<any> {
		return this.http.get(`${this.preferenceUrl}/${preferenceCode}`)
			.map((res: any) => {
				let response = res;
				Object.keys(response.data.preferences).forEach((key) => {
					this.preferences[key] = response.data.preferences[key];
				});
			})
			.catch((error: any) => Observable.throw(error || 'Server error'));
	}
}